module.exports = __webpack_public_path__ + "img/ic_16_switch.92585866.svg";